import { useInfiniteQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { EmailTemplate, Meta } from 'utils/types';
import { useAdminParams } from 'utils/helpers';

import c from '../utils/constants';
import emailTemplateTransformer from '../transformers/emailTemplateTransformer';

interface Result {
  data: EmailTemplate[];
  meta: Meta;
}

export default function useGetEmailTemplatesInfinite(params: {
  [key: string]: any;
}) {
  const { accountId, accountUserId } = useAdminParams();

  const { state } = useProvider();
  const args = state;

  return useInfiniteQuery<
    ReturnType<typeof emailTemplateTransformer.emailTemplates>,
    Error,
    Result
  >({
    queryKey: [c.TEMPLATES, 'INFINITE', params],
    getNextPageParam: (prevData: any) => prevData.nextPage,
    queryFn: async ({ pageParam = 1 }) => {
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: `api/v1/channels/email/templates/`,
            params: { ...params, page: pageParam },
            transformer: emailTemplateTransformer.emailTemplates,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/channels/email/templates/`,
            params: { ...params, page: pageParam },
            transformer: emailTemplateTransformer.emailTemplates,
          },
        }),
      );

      return data;
    },
  });
}
